import { StatusCodes } from 'http-status-codes';
import jwtDecode from 'jwt-decode';
import Cookie from './cookie';
import logger from './log';

interface Token {
  exp: number;
}

export const loginUrl = (pathName: string) =>
  `/app/login?targetUrl=${encodeURIComponent(pathName)}`;

export const handleAuthError = (
  status: number,
  pathName: string,
  redirector?: (path: string) => void,
): boolean => {
  if (status === StatusCodes.UNAUTHORIZED) {
    if (typeof window !== 'undefined') {
      redirector ? redirector(loginUrl(pathName)) : window.location.replace(loginUrl(pathName));
    }
    return true;
  }
  return false;
};

export const isAuth = (time: number = new Date().getTime()): boolean => {
  try {
    const token = Cookie.get('ticket');
    if (!token) {
      return false;
    }
    const decodedToken = jwtDecode<Token>(token);
    return decodedToken?.exp * 1000 >= time;
  } catch (error) {
    logger.error(error);
    return false;
  }
};

export const isAuthCheckAtCookie = (time: number = new Date().getTime()): boolean => {
  try {
    const token = Cookie.get('at');
    if (!token) {
      return false;
    }
    const decodedToken = jwtDecode<Token>(token);
    return decodedToken?.exp * 1000 >= time;
  } catch (error) {
    logger.error(error);
    return false;
  }
};
